import React from 'react';
import A11yFontIcon from 'components/A11yFontIcon';
import MicrositePage from 'components/MicrositePage';
import logoAtmore from './assets/atmore-logo.png';
import logoMontgomery from './assets/montgomery-logo.png';
import logoWetumpka from './assets/wetumpka-logo.png';
import './PromotionLandingPage.css';

export const LOGO_IMAGES = {
  atmore: logoAtmore,
  montgomery: logoMontgomery,
  wetumpka: logoWetumpka
};

export const PROPERTY_BASE_URL = 'https://windcreek.com/';

export const PROPERTY_BASE_URLS = {
  atmore: PROPERTY_BASE_URL + 'atmore/',
  montgomery: PROPERTY_BASE_URL + 'montgomery/',
  wetumpka: PROPERTY_BASE_URL + 'wetumpka/',
  bethlehem: PROPERTY_BASE_URL + 'bethlehem/',
  aruba: PROPERTY_BASE_URL + 'aruba/',
  curacao: PROPERTY_BASE_URL + 'curacao/',
  'chicago southland': PROPERTY_BASE_URL + 'chicagosouthland/'
};

export const PROPERTY_PROMOTIONS_URL_PATHS = {
  atmore: 'promotions',
  montgomery: 'promotions',
  wetumpka: 'promotions',
  bethlehem: 'promotions',
  'chicago southland': 'promotions'
};

export const PROPERTY_HOTEL_BOOKING_URL_PATHS = {
  atmore: 'book-now',
  montgomery: 'book-now',
  wetumpka: 'book-now',
  bethlehem: 'book-now',
  'chicago southland': 'book-now'
};

export const PROPERTY_ADDRESS = {
  atmore: {
    title: 'Wind Creek Atmore',
    phone: '(866) 946-3360',
    addressStreet: '303 Poarch Rd.',
    addressCity: 'Atmore, AL 36502'
  },
  montgomery: {
    title: 'Wind Creek Montgomery',
    phone: '(866) 946-3360',
    addressStreet: '1801 Eddie L Tullis Rd',
    addressCity: 'Montgomery, AL 36117'
  },
  wetumpka: {
    title: 'Wind Creek Wetumpka',
    phone: '(866) 946-3360',
    addressStreet: '100 River Oaks Drive',
    addressCity: 'Wetumpka, AL 36092'
  }
};

function PromotionLandingPage({ match }) {
  const { property, slug } = match.params;

  const propertyBaseUrl = PROPERTY_BASE_URLS[property];
  const propertyPromotionsUrl =
    propertyBaseUrl + PROPERTY_PROMOTIONS_URL_PATHS[property];
  const propertyFooterData = PROPERTY_ADDRESS[property];

  return (
    <div className={`promotion-landing-page ${property}`}>
      <header className="promotion-landing-header tiling-bg">
        <div className="promotion-landing-header-container">
          <a href={propertyBaseUrl} className="logo-wrapper">
            <img
              src={LOGO_IMAGES[property]}
              alt={`Visit ${
                propertyFooterData && propertyFooterData.title
              } website`}
            />
          </a>
          <a href={propertyPromotionsUrl} className="all-promotions-link">
            <span>
              View all <br />
              promotions
            </span>
            <A11yFontIcon icon="chevron-right" alt="" large />
          </a>
        </div>
      </header>
      <div className="promotion-landing-wrapper">
        <MicrositePage
          title={`Wind Creek Promotion Details - ${slug}`}
          url={`${process.env.REACT_APP_PROMOTIONS_IFRAME_BASE_URI}/${slug}`}
          wrapperComponent={false}
          resizing
        />
        <footer className="promotion-landing-footer tiling-bg">
          <div className="promotion-landing-footer-container">
            <div className="promotion-landing-footer-left-content">
              <div className="footer-property-item first">
                &copy;{new Date().getFullYear()} Wind Creek Hospitality
              </div>
              <div className="footer-property-name">
                {propertyFooterData && propertyFooterData.title}
              </div>
              <div className="footer-property-item">
                {propertyFooterData && propertyFooterData.phone}
              </div>
              <div className="footer-property-item">
                {propertyFooterData && propertyFooterData.addressStreet}
              </div>
              <div className="footer-property-item">
                {propertyFooterData && propertyFooterData.addressCity}
              </div>
            </div>
            <div className="promotion-landing-footer-right-content">
              <span className="slogan-line-1">FIND YOUR</span>
              <br />
              WINNING MOMENT.
              <sup>
                <small>&reg;</small>
              </sup>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

PromotionLandingPage.propTypes = {};

export default PromotionLandingPage;
